import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const LANGS = [
  { code: "es", label: "ES", full: "Español" },
  { code: "ca", label: "CA", full: "Català" },
];

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "es").slice(0, 2);

  const change = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem("vel7o_lang", code); } catch {}
  };

  if (compact) {
    return (
      <div className="inline-flex items-center gap-1 rounded-full border border-white/15 bg-white/5 px-1 py-0.5 text-[10px]" data-testid="lang-switcher">
        {LANGS.map((l) => (
          <button key={l.code} type="button" onClick={() => change(l.code)} title={l.full} data-testid={`lang-${l.code}`}
            className={`px-2 py-1 rounded-full font-bold uppercase tracking-wider transition-colors ${current === l.code ? "bg-brand-cyan text-surface-base" : "text-white/60 hover:text-white"}`}>
            {l.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-xs" data-testid="lang-switcher">
      <Globe className="w-3.5 h-3.5 text-white/40" strokeWidth={1.5} />
      {LANGS.map((l) => (
        <button key={l.code} type="button" onClick={() => change(l.code)} data-testid={`lang-${l.code}`}
          className={`px-2 py-0.5 rounded font-bold uppercase tracking-wider transition-colors ${current === l.code ? "text-brand-cyan" : "text-white/40 hover:text-white/80"}`}>
          {l.label}
        </button>
      ))}
    </div>
  );
}
